import mime from "mime-types";

const download = (data, filename) => {
  const decodedString = global.atob(data);
  const sliceSize = 512;
  const byteArrays = [];

  for (let offset = 0; offset < decodedString.length; offset += sliceSize) {
    const slice = decodedString.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {
    type: `${mime.contentType(filename)};charset=utf-8;`
  });
  const src = global.window.URL.createObjectURL(blob);
  const element = global.document.createElement("a");

  element.href = src;
  element.download = filename.replace(/"/g, "");
  element.target = "_blank";

  setTimeout(function() {
    element.click();
  }, 1000);
};

export { download };
